import { CheckCircle2, AlertCircle, CircleHelp, LoaderCircle, CircleDashed } from "lucide-react";
const icons = { success: CheckCircle2, error: AlertCircle, unknown: CircleHelp, loading: LoaderCircle, partial: CircleDashed };
export function StatusBadge({ state = "unknown", children }) {
  const Icon = icons[state] || CircleHelp;
  return <span className="dad-status" data-state={state}><Icon size={14} aria-hidden="true" />{children}</span>;
}
export function ResourceMessage({ resource, label, onRetry }) {
  if (resource.status === "DATA") return null;
  const failed = resource.status === "ERROR";
  return <div className="dad-resource" role={failed ? "alert" : "status"}>
    <StatusBadge state={failed ? "error" : "loading"}>{failed ? `${label}: lettura non disponibile.` : `${label}: caricamento…`}</StatusBadge>
    {failed && onRetry && <button type="button" className="btn-ghost" onClick={onRetry}>Riprova</button>}
  </div>;
}
